export function getSubdomain() {
  const subdomain = window.location.origin.split('://')[1].split('.')[0];

  return subdomain;
}
